module.exports = __webpack_public_path__ + "img/chips100.8f22a94e.png";